import { Dropdown } from 'components/v2/Dropdown'
import { StyledLink } from 'components/v2/Link'
import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`
const Content = styled.div`
  display: flex;
  row-gap: 16px;
  flex-direction: column;
`
const Row = styled.div`
  display: flex;
`
const HeadRow = styled.div`
  display: flex;
  > div {
    color: #717171;
  }
`
const Item = styled.div`
  display: flex;
  width: 180px;
`
const Value = styled.div`
  display: flex;
  width: 120px;
  gap: 16px;
`

//TODO: Add type https://kolors.atlassian.net/browse/NA-18560
export const CsvFileValuesDropdown = ({ data }: { data: TSFixMe[] }): ReactElement => {
  return (
    <Dropdown toggle={<StyledLink>5</StyledLink>} noPadding fitContent>
      <Container>
        <Content>
          <HeadRow>
            <Item>
              <FormattedMessage id="physicalSimsCsv.icc" defaultMessage="ICC" />
            </Item>
            <Value>
              <FormattedMessage id="physicalSimsCsv.number" defaultMessage="Number" />
            </Value>
          </HeadRow>
          {data.map((item, index) => (
            <Row key={index}>
              <Item>
                <span>{item.icc}</span>
              </Item>
              <Value>
                <span>{item.number}</span>
              </Value>
            </Row>
          ))}
        </Content>
      </Container>
    </Dropdown>
  )
}
